import React, { useState } from "react"
import xhr from "xhr"

import config from "../../config"

const LinkUpload = (props) => {
    const { clientID, eventID, uppy } = props
    const [expanded, setExpanded] = useState(false)
    const [linkName, setLinkName] = useState("")
    const [linkUrl, setLinkUrl] = useState("https://")
    const [pending, setPending] = useState(false)
    const isValid = (name, url) => {
        if (!name || !url) {
            return false
        }
        return true
    }

    const handleErrors = (errors) => {
        if (Array.isArray(errors)) {
            errors.forEach((er, i) => {
                setTimeout(() => {
                    uppy.info(er)
                }, 2000 * i)
            })
        } else {
            uppy.info(err)
        }
    }

    const handleCreate = () => {
        if (isValid(linkName, linkUrl)) {
            setPending(true)
            xhr(
                {
                    method: "post",
                    body: JSON.stringify({
                        clientID,
                        eventID,
                        linkName,
                        linkURL: linkUrl,
                    }),
                    uri:
                        "https://crud.v3.invintusmedia.com/asset/createLinkedAsset",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                        Authorization: config.apiAuthentication.vendorName,
                        "Wsc-api-key": config.apiAuthentication.vendorKey,
                    },
                },
                (err, resp) => {
                    setPending(false)
                    if (resp.statusCode === 200) {
                        let body
                        try {
                            body = JSON.parse(resp.body)
                        } catch (err) {
                            handleErrors(err)
                        }
                        if (
                            body.errors &&
                            (body.errors.hasError || body.errors.message)
                        ) {
                            handleErrors(body.errors.message)
                        } else {
                            uppy.info("Link asset created")
                            setExpanded(false)
                        }
                    } else {
                        handleErrors(
                            "request error: " +
                                resp.statusCode +
                                " " +
                                resp.rawRequest.statusText
                        )
                    }
                }
            )
        } else {
            uppy.info("Invalid link asset")
        }
    }

    return (
        <div
            id="link-asset-upload"
            style={{
                backgroundColor: "white",
                color: "gray",
            }}
        >
            <div
                style={{
                    padding: "1rem",
                    overflow: "auto",
                    outline: "none !important",
                }}
            >
                {expanded ? (
                    <div>
                        <div>
                            <label>Link Name</label>
                            <input
                                style={{ outline: "none !important" }}
                                className="form-control"
                                autoFocus
                                value={linkName}
                                onChange={(e) => setLinkName(e.target.value)}
                            />
                        </div>
                        <hr/>
                        <div>
                            <label>Link Url</label>
                            <input
                                style={{ outline: "none !important" }}
                                className="form-control"
                                value={linkUrl}
                                onChange={(e) => setLinkUrl(e.target.value)}
                            />
                        </div>
                        <div style={{ paddingTop: "0.5rem" }}>
                            <button
                                disabled={pending || !isValid(linkName, linkUrl)}
                                onClick={handleCreate}
                                className="btn btn-primary"
                            >
                                {pending ? 'Creating': 'Create'}
                            </button>
                            <button
                                disabled={pending}
                                style={{ marginLeft: "1rem" }}
                                onClick={() => setExpanded(false)}
                                className="btn btn-danger"
                            >
                                Cancel Link Asset
                            </button>
                        </div>
                    </div>
                ) : (
                    <div style={{display: 'inline-flex'}}>
                        <button
                            style={{margin: 'auto'}}
                            className="btn btn-primary"
                            onClick={() => {
                                setExpanded(true)
                                try{
                                    navigator.clipboard
                                    .readText()
                                    .then((text) => {
                                        setLinkUrl(text)
                                    })
                                    .catch((err) => {
                                        //ignore err
                                        // console.log(
                                        //     "err getting clipboard:",
                                        //     err
                                        // )
                                    })
                                } catch (Exception) {
                                    //ignore 
                                }
                            }}
                        >
                            Create Linked Asset
                        </button>
                        <div style={{margin: 'auto', marginLeft: '1rem'}} className="alert alert-info">Linked assets are assets such as documents and webpages hosted outside of Invintus (Video sources not accepted)</div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default LinkUpload
